import { CfMap } from "@webapp/custom-fields/models/custom-fields.models";
import { Plugin, UIPluginAttachPoint } from "@webapp/plugins/plugins.models";

export const getPluginIFrameElement = (params: { accessPoint: UIPluginAttachPoint | string; plugin: Plugin }): HTMLIFrameElement => {
  return document.getElementById(`${params.accessPoint}-${params.plugin.uiPlugin.src}`) as HTMLIFrameElement;
};

export const mergeCustomFields = (existing: CfMap, newCustomFields: CfMap): CfMap => ({
  ...existing,
  ...newCustomFields,
});

export const setParams = (pluginId: string): { pluginId: string } => ({ pluginId: pluginId });
